// extracted by mini-css-extract-plugin
export default {"threedots":"DropdownStyles_threedots__0DdCV","dropdownFavorite":"DropdownStyles_dropdownFavorite__9hHlB","dropdownFavoriteSelected":"DropdownStyles_dropdownFavoriteSelected__V388p"};